module.exports = __webpack_public_path__ + "img/educationalRatings.b86b0bc9.svg";